const KeenSlider = window.KeenSlider

const {
  setInitialised,
  addWheelControls,
  useDots,
} = window.BAO.Carousel.plugins
const { debounce } = window.BAO.Utils

class CompleteTheStyleGallery extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els.slides?.exists || !this.els.slide?.exists) return
    if (this.els.slide.elements.length <= 1) return

    const handleResize = debounce(() => {
      if (this.carousel) {
        this.carousel.update()
        this.carousel.moveToIdx(0)
      } else {
        this.carousel = this.setupCarousel()
      }
    }, 100)

    // The container is hidden (0 width) whenever its tab/panel or drawer
    // isn't visible - ResizeObserver reports that as a resize the moment it
    // actually gains real dimensions, so this alone drives first setup,
    // becoming visible again later, and ordinary window resizes. Debouncing
    // (rather than acting on the first callback) also covers the container's
    // dimensions still settling for a beat after becoming visible (eg.
    // sibling content in the same flex column reflowing as fonts/data load),
    // since perView: 'auto' measures each slide's actual rendered width.
    this.resizeObserver = new ResizeObserver(([entry]) => {
      if (entry.contentRect.width === 0) return

      handleResize()
    })

    this.resizeObserver.observe(this.els.slides.element)
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.resizeObserver?.disconnect()
    this.carousel?.destroy()
  }

  setupCarousel () {
    const dots = this.els.dot?.elements ?? []

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        rubberband: false,
        mode: 'snap',
        slides: {
          perView: 1.5,
          spacing: 2,
        },
        breakpoints: {
          '(min-width: 1024px)': {
            slides: {
              perView: 'auto',
              spacing: 2,
            },
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal'), useDots(dots)],
    )
  }
}

if (!customElements.get('complete-the-style-gallery')) {
  customElements.define('complete-the-style-gallery', CompleteTheStyleGallery)
}
